export const getIIGTrainingPlanIids = () => {
  return [63167342, 21868547];
};

export const isIIGAdmin = (userInfo) => {
  return userInfo && [1250259].includes(userInfo.iid);
};
